<script>import { twMerge } from 'tailwind-merge';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let name;
export let placeholder = undefined;
export let value = undefined;
export let autocomplete = undefined;
export let autocapitalize = 'off';
export let readonly = undefined;
export let tabindex = undefined;
export let disabled = false;
const defaultClass = 'stwui-textarea-title block w-full bg-surface border-0 pt-2.5 text-lg font-medium placeholder-secondary-content placeholder-opacity-80 focus:ring-0';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

<div>
	<slot />
</div>

<label for={name} class="sr-only">Title</label>
<input
	type="text"
	{name}
	id={name}
	{placeholder}
	{autocapitalize}
	{autocomplete}
	{readonly}
	{tabindex}
	{disabled}
	bind:value
	class={finalClass}
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
/>
